module.exports = __webpack_public_path__ + "img/29b22ca.jpg";